import { ApolloError } from '@apollo/client/errors'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { resetSubscriptionError, saveSubscriptionError } from 'reducers/error/subscription'
import { AlertMessages } from 'util/errorMessages'

export const useSubscriptionErrorReset = (error: ApolloError | undefined) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (error && error.message === AlertMessages.FORBIDDEN_ERROR_MESSAGE) {
      dispatch(saveSubscriptionError(error.message))
    } else {
      dispatch(resetSubscriptionError())
    }
  }, [dispatch, error])
}
